<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m87ISb/tc-custom/9780226163444.jpg?1722573928448" alt="This image is the cover for the book Science, Faith and Society"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Science, Faith and Society
      </h1>
      <p class="bookDescription body article font2">
        <p>In its concern with science as an essentially human enterprise, <i>Science, Faith and Society</i> makes an original and challenging contribution to the philosophy of science. On its appearance in 1946 the book quickly became the focus of controversy.<br/><br/> Polanyi aims to show that science must be understood as a community of inquirers held together by a common faith; science, he argues, is not the use of "scientific method" but rather consists in a discipline imposed by scientists on themselves in the interests of discovering an objective, impersonal truth. That such truth exists and can be found is part of the scientists' faith. Polanyi maintains that both authoritarianism and scepticism, attacking this faith, are attacking science itself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Polanyi
      </h2>
      
      <p class="authorDescription body article"><B>Michael Polanyi</B> was a Fellow of the Royal Society of England, a professor of physical chemistry and of social studies at the University of Manchester, and a Fellow of Merton College at Oxford. He was the author of many books, of which the University of Chicago Press has published <I>Personal Knowledge, The Logic of Liberty, Meaning, The Study of Man</I>, and <I>Knowing and Being</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b8ef06a8